import { render, staticRenderFns } from "./Language4.vue?vue&type=template&id=e413fe18&scoped=true"
import script from "./Language4.vue?vue&type=script&lang=js"
export * from "./Language4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e413fe18",
  null
  
)

export default component.exports